<template>
  <q-dialog v-model="spinner.state" persistent>
    <q-card
      class="column items-center justify-center q-pa-md"
      style="width: 300px; border-radius: 20px; background-color: #19B2A3;"
    >
      <div class="text-white text-subtitle1"> {{ spinner.text }} </div>
      <q-linear-progress
        indeterminate
        rounded
        color="white"
        class="q-mt-md"
        style="width: 100%; height: 8px; background-color: #8AFFF3;"
      />
    </q-card>
  </q-dialog>
</template>

<script>
import store from '@/store';
import { computed } from 'vue';
export default({
    name: 'SpinnerComponent',
    setup() {
        return{
            spinner: computed(() => store.getters['spinner/getSpinner']),
        }
    },
})
</script>
<style lang="scss" scoped>


</style>
